import {
  Table,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Box,
  Typography,
} from '@mui/material';
import { FC, ReactNode } from 'react';

type MultipleFieldBoxProps = {
  title?: string;
  children: ReactNode;
};

const MultipleFieldBox: FC<MultipleFieldBoxProps> = ({ title, children }) => {
  return (
    <Box display="flex" flexDirection="column" gap={2}>
      {title && (
        <Typography variant="body1" fontWeight={600} color="var(--base-black)">
          {title}
        </Typography>
      )}
      <TableContainer
        sx={{ boxShadow: 'none', border: 'none' }}
        component={Paper}
      >
        <Table
          sx={{ border: '0.5px solid var(--neutral-500)', outline: 'none' }}
        >
          <TableHead>
            <TableRow>
              <TableCell sx={{ backgroundColor: 'var(--neutral-400)' }}>
                파일명
              </TableCell>
              <TableCell sx={{ backgroundColor: 'var(--neutral-400)' }}>
                파일크기
              </TableCell>
              <TableCell sx={{ backgroundColor: 'var(--neutral-400)' }}>
                등록자 유형
              </TableCell>
              <TableCell sx={{ backgroundColor: 'var(--neutral-400)' }}>
                등록자
              </TableCell>
            </TableRow>
          </TableHead>
          {children}
        </Table>
      </TableContainer>
    </Box>
  );
};

export default MultipleFieldBox;
